import TemplateView from "../../TemplateView"
import Button from "../../components/Button"
import messageResource from "../../messageResource"
import LoadingControlMixin from "../../controls/LoadingControlMixin";

export default class StatusesSectionWrapper extends TemplateView {
    constructor({
        title,
        listContainer,
        onAddBtnClickCb = () => {},
    }) {

        super(null)

        this.params = {
            title
        }

        this.components = {
            listContainer
        }

        this.callbacks = {
            onAddBtnClickCb,
        }

        this.state = {
            newStatusInEdit: false
        }

        this.onStatePropertyChanged('newStatusInEdit', newStatusInEdit => this._setAddNewBtnEditMode(newStatusInEdit))
    }

    templateHtml() {
        return '<div class="statusesSection">' +
               '    <div class="title"><%-title%></div>' +
               '    <div class="addBtn"></div>' +
               '</div>'
    }

    templateModel(){
        return {
            title: this.params.title
        }
    }

    afterRender() {
        this.addNewBtn = new Button({
            label: messageResource.getMessage("workflow_settings.add_new_status"),
            withPlusIcon: true,
            onClickCb: (e) => this.callbacks.onAddBtnClickCb(this.addNewBtn.getEl(), e)
        }).init(this.find('.addBtn'))

        this.components.listContainer.init(this.getEl())
    }

    _setAddNewBtnEditMode(newStatusInEdit){
        this.addNewBtn.getEl().toggleClass('inEdit', newStatusInEdit)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/StatusesSectionWrapper.js